import React from 'react';
import { CheckCircle2, ExternalLink, FileCode, Edit2 } from 'lucide-react';
import { ResultCardMessage } from '../types/space';
interface ResultCardProps {
  message: ResultCardMessage;
}
export function ResultCard({
  message
}: ResultCardProps) {
  return <div className="w-full my-6 pl-11 pr-4" data-id="element-197">
      <div className="w-full bg-white rounded-lg shadow-sm border border-green-200 overflow-hidden" data-id="element-198">
        <div className="p-5" data-id="element-199">
          <div className="flex items-center mb-4" data-id="element-200">
            <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-201">
              <CheckCircle2 className="h-5 w-5 text-green-600" data-id="element-202" />
            </div>
            <div data-id="element-203">
              <h3 className="text-base font-semibold text-gray-900" data-id="element-204">
                {message.title}
              </h3>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-205">Ready for review</p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-206">
            {/* Thumbnail */}
            <div className="w-32 h-24 bg-gray-100 rounded-md border border-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-207">
              <div className="text-center opacity-40" data-id="element-208">
                <div className="w-16 h-2 bg-gray-400 rounded mb-2 mx-auto" data-id="element-209"></div>
                <div className="w-10 h-10 bg-gray-300 rounded mx-auto" data-id="element-210"></div>
              </div>
            </div>

            {/* Files List */}
            <div className="flex-1" data-id="element-211">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2" data-id="element-212">
                Files Updated
              </p>
              <div className="space-y-1.5" data-id="element-213">
                {message.files.map((file, idx) => <div key={idx} className="flex items-center text-sm text-gray-600" data-id="element-214">
                    <FileCode className="h-3.5 w-3.5 mr-2 text-gray-400" data-id="element-215" />
                    {file}
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Actions Footer */}
        <div className="bg-gray-50 px-5 py-3 border-t border-gray-100 flex items-center space-x-3" data-id="element-216">
          <button className="flex items-center justify-center px-4 py-1.5 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-217">
            <ExternalLink className="h-3.5 w-3.5 mr-2" data-id="element-218" />
            Open Preview
          </button>
          <button className="flex items-center justify-center px-4 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-219">
            <FileCode className="h-3.5 w-3.5 mr-2" data-id="element-220" />
            View Code
          </button>
          <div className="flex-1" data-id="element-221"></div>
          <button className="flex items-center justify-center px-3 py-1.5 text-sm font-medium text-gray-400 hover:text-gray-600 transition-colors" data-id="element-222">
            <Edit2 className="h-3.5 w-3.5 mr-1.5" data-id="element-223" />
            Refine
          </button>
        </div>
      </div>
    </div>;
}